import { ExtAdapter, ExtParamInvalidError, ShowFlag } from "@hyext-inner/ext-web-comp";
import { BusType, EventName } from "../../../util/hy";
import { delay } from "../../../util/promise";
import { styleToSelector } from "../../../util/style";
import HyExtAdapterInLiveRoom from "../../adapters/HyExtAdapterInLiveRoom";
import HyExtEndpointModule from "../HyExtEndpointModule";

export default class HyExtWebPopupEndpointModule extends HyExtEndpointModule {
  style:any
  selector:any
  $popup:any
  layout:{
    ref:string
    x:number
    y:number
    width:number
    height:number
    visible:boolean
    alpha:number
  }
  showed:boolean = false
  refWidth:number
  refHeight:number
  screenWidth:number
  screenHeight:number
  // SDK实现
  setLayout(req:SetLayoutReq, adapter:ExtAdapter):Promise<void> {
    this.layout = {
      ...this.layout,
      ...req
    }
    return this.reposition(adapter)
  }
  // 业务方法
  async reposition(adapter:ExtAdapter):Promise<void> {
    const hyAdapter = adapter as HyExtAdapterInLiveRoom
    const { ref, x, y, width, height, visible } = {
      ref: 'player',
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      visible: false,
      ...this.layout
    }
    let $ref:any = null
    let $container:any = null
    if (!ref) {
      return Promise.reject(new ExtParamInvalidError('必须提供参照物参数'))
    } else {
      switch (ref.toLowerCase()) {
        case 'player':
          const { popupLevel } = this.extEndpoint.typeAuthority
          if (popupLevel < 300) {
            $container = $(hyAdapter.getExtContainerUnderBarrage())
          } else {
            $container = $(hyAdapter.getExtPopupContainer())
          }
          const player = await hyAdapter.getPlayer()
          $ref = player.getVideoContainer()
          break
        case 'screen':
          $ref = $('html'),
          $container = $('body')
          break
        case 'chatroom':
          if (visible) {
            hyAdapter.chatroomPanelExtSwitch({ switch: true })
          }
          await delay(100)
          $ref = $('#chatRoom'),
          $container = $('#wrap-ext')
          break
        default:
          return Promise.reject(new ExtParamInvalidError('参照物参数有误'))
      }
      const refWidth = $ref.width()
      const refHeight = $ref.height()
      this.refWidth = refWidth
      this.refHeight = refHeight
      if ($container[0] !== this.$popup.parent()[0]) {
        return Promise.reject(new ExtParamInvalidError('不能改变参照物'))
      } else if (visible) {
        const refOffset = $ref.offset() || { top: 0, left: 0 }
        let popUpWidth = Math.round(refWidth * Math.min(1, Math.max(0, width)))
        popUpWidth -= popUpWidth % 2
        let popUpHeight = Math.round(refHeight * Math.min(1, Math.max(0, height)))
        popUpHeight -= popUpHeight % 2
        this.$popup.width(popUpWidth)
        this.$popup.height(popUpHeight)
        this.bus.getBus(BusType.LAYOUT).emit(EventName.LAYOUT_CHANGE_NOTICE, {
          screenWidth: this.refWidth,
          screenHeight: this.refHeight
        })
        this.showPanel(adapter)
        this.$popup.offset({
          top: refOffset.top + refHeight * Math.min(1, Math.max(0, y)),
          left: refOffset.left + refWidth * Math.min(1, Math.max(0, x))
        })
        if (typeof this.layout.alpha === 'number') {
          this.$popup.css({
            opacity: Math.max(0, Math.min(1, this.layout.alpha))
          })
        }
      } else {
        this.hidePanel(adapter)
      }
    }
    return Promise.resolve()
  }
  unloadPopup(adapter:ExtAdapter) {
    this.extFrame.unload(adapter)
  }
  loadPopup(adapter:ExtAdapter) {
    this.emit('postInitResolved')
    this.extFrame.load(adapter)
  }
  // SDK方法
  onLayoutChange(req:OnLayoutChangeReq, adapter:ExtAdapter):Promise<void> {
    const { target } = req
    this.bus.on(BusType.LAYOUT, EventName.LAYOUT_CHANGE_NOTICE, notice => {
      const { screenWidth, screenHeight } = notice
      if (
        !this.screenWidth ||
        this.screenWidth !== screenWidth ||
        !this.screenHeight ||
        this.screenHeight !== screenHeight
      ) {
        this.screenWidth = screenWidth
        this.screenHeight = screenHeight
        this.extFrame.postMessageToBusiFrame(target, {
          screenWidth,
          screenHeight,
          isLandscape: true
        }, adapter)
      }
    }, true)
    // TODO 调用onLayoutChange固定触发一次
    setTimeout(() => this.bus.getBus(BusType.LAYOUT).emit(EventName.LAYOUT_CHANGE_NOTICE, {
      screenWidth: this.refWidth,
      screenHeight: this.refHeight
    }), 100)
    return Promise.resolve()
  }
  // 覆盖方法
  startup(adapter:ExtAdapter) {
    if (this.hbTimer === 0) {
      this.sys_pageshow_ext_panelshow(adapter)
    }
    super.startup(adapter)
  }
  // 抽象方法
  initEndpoint(adapter:ExtAdapter):Promise<void> {
    const hyExtAdapter = adapter as HyExtAdapterInLiveRoom
    this.style = require('@/sass/popup.scss')
    this.selector = styleToSelector(this.style)
    this.$popup = $(require('@/tpl/popup.html')({
      style: this.style
    }))
    if (this.extEndpoint.extConfig) {
      let { width, height } = this.extEndpoint.typeAuthority
      if (!isNaN(width) && width) {
        width = width - width % 2
        this.$popup.css({ width })
      }
      if (!isNaN(height) && height) {
        height = height - height % 2
        this.$popup.css({ height })
      }
    }
    this.$popup.find('section').append(this.extFrame.iframe)
    if (this.extEndpoint.typeAuthority) {
      switch (this.extEndpoint.typeAuthority.popupContainer) {
        case 1:
          this.layout = { ...this.layout, ref: 'chatroom' }
          $('#wrap-ext').prepend(this.$popup)
          hyExtAdapter.chatroomPanelExtSwitch({ switch: true })
          break
        case 2: {
          let $container
          if (this.extEndpoint.typeAuthority.popupLevel < 300) {
            $container = $(hyExtAdapter.getExtContainerUnderBarrage())
          } else {
            $container = $(hyExtAdapter.getExtPopupContainer())
          }
          this.layout = { ...this.layout, ref: 'player' }
          $container.prepend(this.$popup)
          break
        }
        default:
          this.layout = { ...this.layout, ref: 'screen' }
          $('body').append(this.$popup)
          break
      }
    } else {
      this.layout = { ...this.layout, ref: 'screen' }
      $('body').append(this.$popup)
    }
    // 监听容器大小变化
    if (this.extEndpoint.typeAuthority && this.extEndpoint.typeAuthority.popupContainer === 2) {
      hyExtAdapter.onPageFullScreen(() => this.reposition(adapter))
    }
    $(window).on('resize', () => this.reposition(adapter))
    this.reposition(adapter)
    this.sys_pageshow_ext_list(adapter)
    this.sys_startup_ext_interactive(adapter)
    return Promise.resolve()
  }
  statusNotice(extTypeIconInfo:MidExtQuery.ExtTypeIconInfo, adapter:ExtAdapter):Promise<void> {
    if (extTypeIconInfo) {
      this.extEndpoint.typeAuthority.extTypeIconInfo = extTypeIconInfo
    }
    const { showFlag } = this.extEndpoint.typeAuthority.extTypeIconInfo
    if (showFlag & Number(ShowFlag.PANEL)) {
      this.loadPopup(adapter)
    } else {
      // TODO
      this.$popup.hide()
      this.unloadPopup(adapter)
    }
    return Promise.resolve()
  }
  postInit() {
    const { showFlag } = this.extEndpoint.typeAuthority.extTypeIconInfo
    if (showFlag & Number(ShowFlag.PANEL)) {
      this.loaded = true
      return Promise.resolve()
    } else {
      return new Promise<void>(resolve => {
        this.once('postInitResolved', () => resolve())
      })
    }
  }
  showEndpointPanel(adapter:ExtAdapter): Promise<void> {
    // 第一次show的时候才触发onLoad的生命周期
    if (!this.showed) {
      this.showed = true
      this.postLifeLoad(adapter)
      this.postLifeAppear(adapter)
    } else {
      if (!this.$popup.is(':visible')) {
        this.postLifeEnterForeground(adapter)
        this.postLifeAppear(adapter)
      }
    }
    this.$popup.show()
    return Promise.resolve()
  }
  hideEndpointPanel(adapter:ExtAdapter): Promise<void> {
    if (this.$popup.is(':visible')) {
      this.postLifeLeaveForeground(adapter)
      this.postLifeDisappear(adapter)
    }
    this.$popup.hide()
    return Promise.resolve()
  }
  showEndpointEntrance(): Promise<void> {
    return Promise.resolve()
  }
  hideEndpointEntrance(): Promise<void> {
    return Promise.resolve()
  }
  ready(): Promise<boolean> {
    return Promise.resolve(true)
  }
  showSupError(): Promise<void> {
    return Promise.resolve()
  }
  getModalContainer(): Promise<any> {
    return Promise.resolve($('body'))
  }
  textNotice(tips: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
  close(content: string): Promise<void> {
    this.logger.warn('显示下线提示', content)
    this.extFrame.destroy()
    return Promise.resolve()
  }
}